import { Box, Divider, Typography } from "@mui/material";

import { ExternalLinks } from "../ExternalLinks/ExternalLinks";

export function AppFooterCopyright() {
  return (
    <Typography color="text.secondary" fontSize="0.66rem">
      {`©${new Date().getFullYear()} CrowdCoursing - All Rights Reserved`}
    </Typography>
  );
}

export interface FooterProps {
  externalLinksProps: React.ComponentProps<typeof ExternalLinks>;
  /** Narrow collapsed rail: hide nonessential footer copy. */
  railCompact?: boolean;
  slotProps?: {
    dividerContainerProps?: React.ComponentProps<typeof Box>;
    dividerProps?: React.ComponentProps<typeof Divider>;
    contentContainerProps?: React.ComponentProps<typeof Box>;
    isEmpty?: boolean;
  };
}

export const Footer = ({ externalLinksProps, railCompact, slotProps }: FooterProps) => {
  if (railCompact && !slotProps?.isEmpty) {
    return null;
  }

  // Leaves room for Tawk on non-mobile screens
  if (slotProps?.isEmpty) {
    return (
      <>
        <Box
          alignContent="flex-end"
          display="grid"
          gap="1rem"
          gridAutoColumns="minmax(0, auto)"
          gridAutoFlow="row"
          height={railCompact ? "auto" : "5em"}
          minHeight={railCompact ? 0 : undefined}
          textAlign="center"
          {...slotProps?.contentContainerProps}
        >
          {railCompact ? null : <AppFooterCopyright />}
        </Box>
      </>
    );
  }
  return (
    <>
      <Box
        display="grid"
        gap="1rem"
        gridAutoColumns="minmax(0, auto)"
        gridAutoFlow="row"
        textAlign="center"
        {...slotProps?.dividerContainerProps}
      >
        <Box marginTop=".5em">
          <Divider {...slotProps?.dividerProps} />
        </Box>
      </Box>
      <Box
        display="grid"
        gap="1rem"
        gridAutoColumns="minmax(0, auto)"
        gridAutoFlow="row"
        textAlign="center"
        {...slotProps?.contentContainerProps}
      >
        <ExternalLinks {...externalLinksProps} />
        <AppFooterCopyright />
      </Box>
    </>
  );
};
